import { render, staticRenderFns } from "./DocumentsCard.vue?vue&type=template&id=1c2a7853&"
import script from "./DocumentsCard.vue?vue&type=script&lang=js&"
export * from "./DocumentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports